var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      staticClass: "international",
      staticStyle: { display: "flex", "align-items": "center" },
      attrs: { width: "350", trigger: "click", placement: "top-end" },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
        },
        [
          _c("div", { staticStyle: { height: "30px" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  float: "left",
                  "font-size": "16px",
                  "font-weight": "bold",
                },
              },
              [_c("span", [_vm._v(_vm._s(_vm.$t("webmsg.web_msg")))])]
            ),
            _vm.showSetting
              ? _c("div", { staticStyle: { float: "right" } }, [
                  _c(
                    "a",
                    {
                      staticStyle: {
                        "text-detext-decoratext-decoration": "none",
                        cursor: "point",
                      },
                      attrs: { href: "#" },
                      on: { click: _vm.msgSetting },
                    },
                    [_vm._v("消息规则")]
                  ),
                ])
              : _vm._e(),
          ]),
          _c("el-divider", { staticClass: "msg-line-class" }),
          _c(
            "el-table",
            {
              staticClass: "de-msg-data-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.data,
                "show-header": false,
                "highlight-current-row": true,
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "content", label: _vm.$t("commons.name") },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", { staticClass: "start-item" }, [
                          _c(
                            "div",
                            {
                              staticClass: "filter-db-row star-item-content",
                              on: {
                                click: function ($event) {
                                  return _vm.showDetail(scope.row)
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "title-div" }, [
                                _c("span", [
                                  _vm._v(
                                    "【" +
                                      _vm._s(
                                        _vm.getTypeName(scope.row.typeId)
                                      ) +
                                      "】  " +
                                      _vm._s(scope.row.content)
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "title-div" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("timestampFormatDate")(
                                        scope.row.createTime
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "msg-foot-class", on: { click: _vm.showMore } },
            [
              _c(
                "el-row",
                {
                  staticStyle: {
                    padding: "5px 0",
                    "margin-bottom": "-5px",
                    cursor: "point",
                  },
                  on: { click: _vm.showMore },
                },
                [_c("span", [_vm._v(_vm._s(_vm.$t("webmsg.show_more")))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _c(
            "el-badge",
            {
              staticClass: "item",
              attrs: {
                value:
                  _vm.visible && !_vm.loading
                    ? _vm.paginationConfig.total
                    : _vm.count,
                hidden: !_vm.count && !_vm.paginationConfig.total,
                max: 99,
              },
            },
            [
              _c("svg-icon", {
                attrs: {
                  "class-name": "notification",
                  "icon-class": "notification",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }